/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrderVoucher,
    OrderVoucherFromJSON,
    OrderVoucherFromJSONTyped,
    OrderVoucherToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrderVoucherDataFrame
 */
export interface OrderVoucherDataFrame {
    /**
     * 
     * @type {number}
     * @memberof OrderVoucherDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OrderVoucherDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof OrderVoucherDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<OrderVoucher>}
     * @memberof OrderVoucherDataFrame
     */
    data: Array<OrderVoucher>;
}

export function OrderVoucherDataFrameFromJSON(json: any): OrderVoucherDataFrame {
    return OrderVoucherDataFrameFromJSONTyped(json, false);
}

export function OrderVoucherDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderVoucherDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(OrderVoucherFromJSON)),
    };
}

export function OrderVoucherDataFrameToJSON(value?: OrderVoucherDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(OrderVoucherToJSON)),
    };
}


